interface HostProps {
  item: string | undefined | null;
  suffix?: string;
}

export default function HostWrapText({ item, suffix }: HostProps): JSX.Element | null {
  if (!item) {
    return null;
  }

  const renderItem = suffix ? `${item}${suffix}` : item;

  return <span>{renderItem}</span>;
}

const defaultProps: Pick<HostProps, 'suffix'> = {
  suffix: undefined,
};

HostWrapText.defaultProps = defaultProps;
